import React, { useEffect, useState } from "react";
import { Typography } from "@plum-xoxo/admin-dsm";

const TotalData = ({
  currencyCode = "INR",
  fetchCount,
  isSuperAdmin,
  title,
  walletCompany = 1,
  columns,
}) => {
  const [totalSent, setTotalSent] = useState(0);
  const [totalRedeemed, setTotalRedeemend] = useState(0);
  const [totalSentAmount, setTotalSentAmount] = useState(0);
  const [totalRedeemedAmount, setRedeemedAmount] = useState(0);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let params = {};
    if (["reward points", "reward code"].includes(title)) {
      params = {
        offset: 0,
        limit: 10,
        isSuperAdmin: isSuperAdmin,
      };
    } else if (title === "gift cards") {
      params = {
        url: "analytics/plumpro",
        is_superAdmin: isSuperAdmin,
        is_multiAdmin: walletCompany === 1,
      };
    }
    if (fetchCount) {
      setLoading(true);
      fetchCount(params).then((res) => {
        setLoading(false);
        if (title === "reward points") {
          const data =
            res?.data?.getPlumMultiAdminPointsCount ||
            res?.data?.getPlumPointsReport;
          setTotalSent(data?.totalPoint || 0);
          setTotalRedeemend(data?.totalUsedPoint || 0);
        } else if (title === "reward code") {
          const data = res?.data?.getPlumMultiAdminVoucherCount;
          setTotalSent(data?.totalSentNumber || 0);
          setTotalRedeemend(data?.totalReedeemedNumber || 0);
          setTotalSentAmount(data?.totalSentAmount || 0);
          setRedeemedAmount(data?.totalRedeemedAmount || 0);
        } else if (title === "gift cards") {
          const data = res?.data?.getTotalReportCount;
          setTotalSent(data?.res[0]?.sent_amount || 0);
        }
      });
    }
  }, [columns]);

  return (
    !loading && (
      <div className="box p-24 mt-16 d-flex">
        <div>
          <Typography.HelperText className="mb-0" color="dark" shade="c200">
            {title === "reward code"
              ? "Total Codes Sent"
              : title === "reward points"
              ? "Total Points Sent"
              : `Total Voucher Sent (${currencyCode})`}
          </Typography.HelperText>
          <Typography.H3 className="mt-4" color="dark" shade="c300">
            {parseFloat(totalSent).toLocaleString()}{" "}
            {title === "reward code" && (
              <Typography.BodySmall
                color="dark"
                shade="c200"
                className="inline-block mb-0"
              >
                ({currencyCode} {totalSentAmount.toLocaleString()})
              </Typography.BodySmall>
            )}
          </Typography.H3>
        </div>

        {title !== "gift cards" && (
          <>
            <div
              style={{
                borderRight: "1px solid #E7E9EB",
              }}
              className="mx-44"
            ></div>

            <div>
              <Typography.HelperText className="mb-0" color="dark" shade="c200">
                {title == "reward code"
                  ? "Total Codes Redeemed"
                  : "Total Points Redeemed"}
              </Typography.HelperText>
              <Typography.H3 className="mt-4" color="dark" shade="c300">
                {totalRedeemed.toLocaleString()}{" "}
                {title === "reward code" && (
                  <Typography.BodySmall
                    color="dark"
                    shade="c200"
                    className="inline-block mb-0"
                  >
                    ({currencyCode} {totalRedeemedAmount.toLocaleString()})
                  </Typography.BodySmall>
                )}
              </Typography.H3>
            </div>
          </>
        )}
      </div>
    )
  );
};

export default TotalData;
